import React from "react";
import { ReactComponent as Upload } from "../Global Icons/Upload Image.svg";

const TextInput = ({
  ref,
  label,
  placeholder,
  span,
  type,
  forImage = false,
  id,
  multiple = false,
  onChange,
  bgBlue = false,
  name,
  disabled = false,
  readOnly = false,
  required,
  onBlur,
  max,
  onKeyDown,
  className,
  title,
  min,
  value,
  onInput,
  row
}) => {
  const handleTrimOnBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      const event = {
        target: {
          name: e.target.name,
          value: trimmed,
        },
      };
      onChange?.(event);
    }

    onBlur?.(e);
  };

  return forImage ? (
      <div className="div_label_span_input">
        <span
          className={bgBlue ? "bgBlue_label" : "span-class-text"}
          htmlFor={id}
        >
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </span>
        <input
          ref={ref}
          id={id}
          disabled={disabled}
          required={required}
          onChange={onChange}
          className={className}
          title={title}
          multiple={multiple}
          onBlur={handleTrimOnBlur}
          hidden
          name={name}
          onKeyDown={onKeyDown}
          readOnly={readOnly}
          onWheel={(e) => e.target.blur()}
          type={type}
          placeholder={placeholder}
          max={max}
          min={min}
          value={value}
          onInput={onInput}

        />
        <label
          className="label-class-image"
          style={{ lineHeight: "260px" }}
          htmlFor={id}
        >
          <Upload></Upload>
        </label>
      </div>
    ) : (
      <div className="div_label_span_input">
        <label className={bgBlue ? "bgBlue_label" : ""} for={id}>
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </label>
        {type === "textarea" ? (
          <textarea
            id={id}
            name={name}
            className={className}
            disabled={disabled}
            required={required}
            readOnly={readOnly}
            placeholder={placeholder}
            onChange={onChange}
            onBlur={handleTrimOnBlur}
            onKeyDown={onKeyDown}
            onWheel={(e) => e.target.blur()}
            title={title}
            maxLength={max}
            minLength={min}
            value={value}
            onInput={onInput}
            rows={row}
            style={{ resize: "vertical", padding: "10px", borderRadius: "4px", border: "1px solid #ccc", width: "100%", borderRadius: "20px" }}
          />
        ) : (
          <input
            id={id}
            disabled={disabled}
            required={required}
            onChange={onChange}
            className={className}
            title={title}
            onBlur={handleTrimOnBlur}
            onKeyDown={(e) => {
              if (onKeyDown) onKeyDown(e);
              if (
                type === "number" &&
                (e.key === "-" || e.key === "e" || e.key === "E")
              ) {
                e.preventDefault();
              }
            }}
          onWheel={(e) => e.target.blur()}
          name={name}
          readOnly={readOnly}
          type={type}
          placeholder={placeholder}
          max={max}
          min={min}
          value={value}
          onInput={onInput}
        />
      )}
    </div>
  );
};

export default TextInput;
